var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:[_vm.themeClass ,'app-wrapper']},[_c('sidebar',{staticClass:"sidebar-container"}),_c('div',{staticClass:"main-container"},[_c('navbar',{staticClass:"fixed"}),_c('app-main')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }